import {Observable} from "rxjs";

export enum ConfirmationDialogSignal {
  Continue = 'Continue',
  Cancel = 'Cancel'
}

export enum ConfirmationDialogColor {
  Dark = 'dark',
  Light = 'light'
}

export interface ConfirmationDialogData {
  title: string,
  description: string,
  descriptionBelowExtraData?: string,
  extraData?: string[],
  extraDataPrefix?: string;
  remarkDescriptionPrefix?: string,
  remarkDescription?: string,
  color: ConfirmationDialogColor
  affirmText?: string,
  cancelText?: string,  
  hideCancelButton?: boolean;
  affirmAction?(): Observable<void>;
  cancelAction?(): Observable<void>;
  boldDescriptionBelowExtraData? : boolean;
}

export const CONFIRMATION_DIALOG_CLASS = 'modal-dialog';
export const EXTENDED_DIALOG_CLASS = 'modal-extended';
export const GENERIC_DIALOG_CLASS = 'modal-generic';
